import React , {useState} from 'react';
import { Link , Navigate, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { signInWithEmailAndPassword , auth , query , collection , db , where , getDocs } from '../firebase';
import './Login.css';


const Login = () => {

  let navigate = useNavigate();

  const [email , setEmail ] = useState('');
  const [password , setPassword] = useState('');
  const [loading , setLoading] = useState(false);
  const [error , setError] = useState('');
  const [success , setSuccess ] = useState(false);
  
  const loginUser =  async (e) => {
      
      e.preventDefault();
      setLoading(true);

      const q = query(collection(db, "users"), where("email", "==", email ) );
   
      const querySnapshot = await getDocs(q);
    
      const usersDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';

      if (email === ''  ) {
          setError('يرجى ادخال ايميل المستخدم')
  }

  if (password === ''  ) {
          setError('يرجى ادخال كلمة مرور المستخدم')
  }

  setTimeout(() => {
    setLoading(false);
    setError('');
  } , 2500);

     

      signInWithEmailAndPassword(auth, email, password)
      .then(() => {
          

        let objectUser = {
          name: usersDataArray[0].name ? usersDataArray[0].name : '' ,
          age: usersDataArray[0].age ? usersDataArray[0].age : '',
          country: usersDataArray[0].country ? usersDataArray[0].country : '',
          email: usersDataArray[0].email ? usersDataArray[0].email : '',
          id: usersDataArray[0].id ? usersDataArray[0].id : ''
        }

              localStorage.setItem("tourst_compass_user",JSON.stringify(objectUser));
              setSuccess(true);
              setLoading(false);

              setTimeout(() => {
                setSuccess(false);
                navigate('/');
              } , 2500)
             
                
         
      }) .catch(() => {
    
       
          setError('فشل تسجيل الدخول يرجى التحقق من بياناتك');
             setLoading(false);
      });;
      


  }

  const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

  return (
    <div className='main_login_page' >

{ user ? <Navigate to="/" replace /> : ''  }
    <Navbar />

    <div className="flex-col">

   
    <div className="login_div_box">

    <div className="image_div" style={{ background: " linear-gradient(  rgba(0,0,0,0.4) , #010101 ) ,url('/images/landscape/1.jpg') center / cover" }} >
      <img className='logo_login_div' src="/images/icons/logo-white.png" alt="" />
    </div>

    <div className="login_div">
   
          <h1 className="headline_login_form"> ! مرحبا مجددا </h1>
          <div className="mt-2"></div>

          {error && (
                            <>
                            <h1 className="mb-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}

      <form onSubmit={loginUser} >
      <div className="input_form_div">
          <label htmlFor="" className="login_label_form">الايميل</label>
          <input value={email} onChange={(e) => setEmail(e.target.value) } type="email" className="login_input_form " />
        </div>

        <div className="input_form_div">
          <label htmlFor="" className="login_label_form">كلمة المرور</label>
          <input value={password} onChange={(e) => setPassword(e.target.value) } type="password" className="login_input_form " />
        </div>

        <div className='input_form_div' >

        {loading ? (
              <>
                                <img src="/images/icons/loading-spinner.gif" className='loading_spinner' alt="" />
                            </>
            ) : (
              <button type='submit' className="mt-2 btn_login">  تسجيل الدخول</button>
            )}

        
        </div>

        <div className='input_form_div' >
        <p className="mt-2 main_para text-green"> ليس لديك حساب ؟ قم   <Link className='a_link a_underline' to="/signUp" >  بانشاء حساب الان </Link> </p>
        </div>
      </form>


    </div>

    

    </div>

    </div>

    </div>
  )
}

export default Login